export default __webpack_public_path__ + "static/media/vjcet-campus.e69791f9.jpg";